import { ITheme } from "../../utils/theme";

export const MenuBoxStyle = (theme: ITheme) => ({
  padding: 1,
  paddingBottom: 0,
  background: theme.palette.coldWhite
})

export const MenuStyle = () => ({
  minHeight: 'calc(100vh - 8px)',
  boxSizing: 'border-box',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: 'none',
  paddingBottom: 0,
});

export const MenuSubHeaderStyle = () => ({
  padding: 0,
  position: 'relative',
  background: 'transparent',
});

export const MenuSubHeaderItemButtonStyle = () => ({
  background: 'transparent',
  paddingBottom: 1,
  width: '100%',
  '&:hover': {
    background: 'transparent',
  }
})

export const MenuSubFooterStyle = (theme: ITheme) => ({
  height: '50px',
  width: '100%',
  marginTop: 'auto',
});


export const MenuListItemStyle = () => ({
  '> :nth-last-of-type(2)': {
    marginBottom: '10px',
  }
})
